import gql from "graphql-tag";
const field = `
id
price
model
createdAt
updatedAt
`;

const createVehicleType = gql`
  mutation(
    $price: Float
    $model: String
  ) {
    createVehicleType(
      data: {
        price: $price
        model: $model
      }
    ) {
      ${field}
    }
  }
`;

const updateVehicleType = gql`
  mutation(
    $id: ID!
    $price: Float
    $model: String
  ) {
    updateVehicleType(
      id: $id
      data: {
        price: $price
        model: $model
      }
    ) {
      ${field}
    }
  }
`;

const deleteVehicleType = gql`
  mutation($id: ID!) {
    deleteVehicleType(id: $id) {
      id
    }
  }
`;

const getListVehicleType = gql`
  query($limit: Int, $page: Int, $query: String) {
    getListVehicleType(query: $query paging: { limit: $limit, page: $page }) {
      ${field}
      author {
        id
        username
        fullname
      }
    }
  }
`;

const getDetailVehicleType = gql`
  query($id: ID!) {
    getDetailVehicleType(id: $id) {
      ${field}
      author {
        id
        username
        fullname
      }
    }
  }
`;

const hasTaxCodeInVehicleType = gql`
  query($taxCode: String!) {
    hasTaxCodeInVehicleType(taxCode: $taxCode)
  }
`;

export default {
  createVehicleType,
  updateVehicleType,
  deleteVehicleType,
  getListVehicleType,
  getDetailVehicleType,
  hasTaxCodeInVehicleType,
};
